// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { VehicleDeviceManagementAdminAreaId } from './VehicleDeviceManagementAdminAreaId'
import { VehicleDeviceManagementAdminAreaNavigation } from './VehicleDeviceManagementAdminAreaNavigation'
import { VehicleDeviceManagementAdminAreaRoutes } from './VehicleDeviceManagementAdminAreaRoutes'

const LazyVehicleDeviceManagementAdminComponent = lazy(
  () => import('./VehicleDeviceManagementAdminArea'),
)

const VehicleDeviceManagementAdminComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVehicleDeviceManagementAdminComponent />
  </SuspenseLoadingWrapper>
)

export const VehicleDeviceManagementAdminArea = {
  id: VehicleDeviceManagementAdminAreaId,
  requiredRight: BoumRight.AREA_VEHICLE_DEVICE_MANAGEMENT,
  NavigationComponent: VehicleDeviceManagementAdminAreaNavigation,
  route: {
    path: VehicleDeviceManagementAdminAreaRoutes.route,
    component: VehicleDeviceManagementAdminComponent,
  },
}
